__turbopack_context__.v({
  "number": "remaining-checks-module-scss-module__bwmg5q__number",
  "root": "remaining-checks-module-scss-module__bwmg5q__root",
  "text": "remaining-checks-module-scss-module__bwmg5q__text",
});
